import styled from "styled-components";

export const BlogComponentMainDiv = styled.main``;

export const BlogComponentHeroMainDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 210px 40px 100px;
    align-items: center;
    justify-content: center;
  }
  .blog-hero-container {
    max-width: 1140px;
    display: flex;
    flex-direction: column;
    gap: 60px;
    align-items: center;

    width: 100%;
    flex: 1;
  }
  .blog-hero-header-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 700px;
    align-items: center;
  }
  .blog-hero-header-text-container {
    text-align: center;
    > h1 {
      font-size: 76px;
      text-align: center;
      line-height: 1.1em;
    }
  }
  .blogs-featured-container {
    display: flex;
    border: 1px solid red;
    width: 100%;
    flex: 1;
    border-radius: 12px;
    background: black;
    display: flex;
    gap: 10px;
  }
  .blogs-featured-wrapper {
    padding: 30px;
    width: 100%;
    border-radius: 12px;
    flex: 1;
    display: flex;
    justify-content: space-between;
    gap: 16px;
  }
  .blog-featured-right {
    max-width: 472px;
    width: 100%;
    flex: 1;
    display: flex;
    flex-flow: column;
    padding: 0 0 0 30px;
    gap: 40px;
  }
  .blog-featured-right-heder-container {
    width: 100%;
    flex: 1;
    display: flex;
    flex-flow: column;
    gap: 24px;
  }
  .blog-featured-header-text-wrapper {
    width: 100%;
    flex: 1;
    display: flex;
    flex-flow: column;
    gap: 10px;
  }
  .blog-featured-contrast-text-wrapper {
    > p {
      color: rgba(22, 77, 170, 1);
      text-transform: uppercase;
      line-height: 1.2em;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .blog-featured-text-wrapper {
    > p {
      font-size: 17px;
      font-weight: 400;
      line-height: 1.5em;
      opacity: 0.8;
    }
    > h2 {
      font-size: 44px;
      line-height: 1.2em;
    }
  }
  .blog-featured-button-wrapper {
    width: fit-content;
  }

  .blog-featured-image-container {
    width: 100%;
    flex: 1;
    max-width: 518px;
  }
  .blog-featured-image-wrapper {
    width: 100%;
    flex: 1;
    max-width: 518px;
    height: 378px;
    display: flex;
    border: 1px solid red;
    border-radius: 12px;
    transition: all 0.4s;
    position: relative;

    overflow: hidden;
    > img {
      transition: transform 0.3s ease;

      border-radius: 12px;
    }

    &:hover {
      > img {
        transform: scale(1.1);
      }
    }
  }
`;
export const BlogComponentBlogsDiv = styled.section`
  > div {
    padding: 100px 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .blogs-container {
    width: 100%;
    display: flex;
    gap: 60px;
    flex-flow: column;
    max-width: 1140px;
  }
  .blogs-wrapper {
    flex: 1 0 0;
    grid-template-columns: repeat(3, minmax(50px, 1fr));
    grid-auto-rows: min-content;
    justify-content: center;
    gap: 24px;
    width: 100%;
    flex: 1;
    height: min-content;
    padding: 0;
    display: grid;
    position: relative;
  }
`;

export const BlogComponentBlogItemDiv = styled.div`
  width: 100%;
  height: 100%;
  .blog-item-link-container {
    border: 1px solid #191919;
    border-radius: 16px;
    background: #060606;

    padding: 24px;
    display: flex;
    gap: 24px;
    flex-flow: column;
    &:hover {
      .blog-item-text-wrapper {
        > h3 {
          opacity: 1;
        }
      }
      .blog-item-img-container {
        > img {
          transform: scale(1.1);
        }
      }
    }
  }
  .blog-item-img-container {
    height: 250px;
    width: 100%;
    overflow: hidden;
    border-radius: 16px;

    > img {
      transition: transform 0.3s ease;

      border-radius: 16px;
    }

    &:hover {
      > img {
        transform: scale(1.1);
      }
    }
  }
  .blog-item-text-container {
    display: flex;
    flex-flow: column;
    gap: 16px;
  }
  .blog-item-text-wrapper {
    > h3 {
      font-size: 21px;
      font-weight: 500;
      line-height: 1.3em;
      opacity: 0.7;
      transition: all 0.3s ease;
    }
    > p {
      font-size: 15px;
      font-weight: 500;
      line-height: 1.3em;
      opacity: 0.9;

      text-transform: uppercase;
    }
  }
  .blog-item-topic-text-container {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
  }
  .blog-topic-text-wrapper {
    > p {
      font-size: 15px;
      font-weight: 500;
      line-height: 1.3em;
      text-transform: uppercase;
      color: rgba(22, 77, 170, 1);
    }
  }
`;
